import { render } from "./z-page.vue?vue&type=template&id=5ae58320&scoped=true&ts=true"
import script from "./z-page.vue?vue&type=script&lang=ts"
export * from "./z-page.vue?vue&type=script&lang=ts"

import "./z-page.vue?vue&type=style&index=0&id=5ae58320&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae58320"],['__file',"src/components/base/z-page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ae58320"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ae58320', __exports__)) {
    console.log('reload')
    api.reload('5ae58320', __exports__)
  }
  
  module.hot.accept("./z-page.vue?vue&type=template&id=5ae58320&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5ae58320', render)
  })

}


export default __exports__